import *  as _ from "lodash";
import { wijmo, wjcInput } from "../../grapecity";

export class SpinnerComboBox {


    promise: Promise<any>;
    content: JQuery<any>;
    container: JQuery<any>;

    comboBox: JQuery<HTMLElement>;
    comboBoxCtrl: wjcInput.ComboBox;

    btnDecrease: JQuery<HTMLElement>;
    btnIncrease: JQuery<HTMLElement>;

    items: { value: any; text: string }[];
    cssClass: string;

    onChange: (value: any) => void;



    //private _selectedIndex: number;

    // Getter宣言
    private get selectedIndex(): number {
        //return this._selectedIndex;
        return this.comboBoxCtrl?.selectedIndex;
    }

    // Setter宣言
    private set selectedIndex(selectedIndex: number) {
        //this._selectedIndex = selectedIndex;
        if (this.comboBoxCtrl) {
            this.comboBoxCtrl.selectedIndex = selectedIndex;
        }
        //this.onChange?.call(this, this.value);
    }

    // Getter宣言
    get selectedValue(): any {
        //return this._value;
        return this.comboBoxCtrl?.selectedValue;
    }

    // Setter宣言
    set selectedValue(value: any) {
        //if (this._value == value) { return; }
        //this._value = value;
        if (this.comboBoxCtrl) {
            this.comboBoxCtrl.selectedValue = value;
        }
        //this.onChange?.call(this, this.comboBoxCtrl.selectedValue);
    }

    /** */
    private value: any;

    private _disabled: boolean;

    public get disabled(): boolean {
        return this._disabled;
    }

    public set disabled(value: boolean) {
        this._disabled = value;
        if (this._disabled) {
            this.content.addClass('disabled');
        } else {
            this.content.removeClass('disabled');
        }
    }

    private _visible: boolean;

    public get visible(): boolean {
        return this._visible;
    }

    public set visible(value: boolean) {
        this._visible = value;
        if (this._visible) {
            this.content.removeClass('d-none');
        } else {
            this.content.addClass('d-none');
        }
    }

    /** */
    private _isEventSuspended;
    /** */
    get isEventSuspended() {
        return this._isEventSuspended;
    };

    /**
     * イベントの一時休止
     */
    suspendEvent() {
        this._isEventSuspended = true;
    }
    /**
     * イベントの再開
     */
    resumeEvent() {
        this._isEventSuspended = false;
    }



    /**
     * 
     * @param option
     */
    constructor(container, items: { value: any; text: string }[], value?: any, option?: { cssClass?: string; visible?: boolean }) {
        this.container = $(container);
        this.items = items;
        this.value = value ?? null;
        this.cssClass = option?.cssClass || null;
        this.initialize();
        this.build();
        this.setEvents();
        this.completed();
        this.visible = option?.visible == false ? false : true;
    }

    /**
     * 
     */
    private initialize() {
        //if (this.content.not('.spinner')) {
        //    this.content.addClass('spinner');
        //}
    }
    /**
     * 
     */
    private build() {

        this.content = $('<div class="spinnerComboBox">');
        //this.content.addClass('mx-1');
        if (this.cssClass) {
            this.content.addClass(this.cssClass);
        }
        const group = $('<div class="input-group" >');
        this.btnIncrease = this.createButton('btnIncrease');
        this.btnDecrease = this.createButton('btnDecrease');
        this.comboBox = this.createComboBox();
        group.append(this.btnDecrease);
        group.append(this.comboBox);
        group.append(this.btnIncrease);
        this.content.append(group);

        if (this.container && this.container.length > 0) {
            this.container.append(this.content);
        }

    }

    /**
     * 
     * @param type
     * @returns
     */
    private createButton(type: 'btnIncrease' | 'btnDecrease') {
        const button = $(`<div class="btn btn-outline-secondary rounded-0 p-0 btn-number" data-type="${type}">`);
        const iconName = (type == "btnIncrease") ? 'arrow_right' : 'arrow_left';
        const icon = $(`<i class="material-icons">${iconName}</i>`);
        button.append(icon);
        return button;
    }
    /**
     * 
     * @param type
     * @returns
     */
    private createComboBox() {
        const comboBox = $(`<div class="border border-secondary combobox">`);
        this.comboBoxCtrl = new wjcInput.ComboBox(comboBox, {
            displayMemberPath: 'text',
            selectedValuePath: 'value',
            //共通コンポーネントにしたいので、これは廃止!!
            //format: 'MM/dd日(ddd)',
            itemsSource: this.items ?? [],
            selectedValue: this.value,
            //#8037
            //案１
            //isReadOnly: true,//これはダメ
            //#8038
            clickAction: wjcInput.ClickAction.Toggle,
            selectedIndexChanged: (sender) => {
                this.setBehavior();
                if (!this.isEventSuspended) {

                    this.onChange?.call(this, this.comboBoxCtrl.selectedValue);
                }
            },
        });

        //#8037
        //案２
        //this.comboBoxCtrl.inputElement.readOnly = true;//これもダメ
        //案３
        //wjcInput.ComboBoxはDefaultで内包されたinputElementにreadOnly属性が付与されていると、DoropDownも表示されなくなる!!
        //this.comboBoxCtrl.inputElement.style.pointerEvents = 'none';//これしてしまうと#8038が実現出来なくなる
        //案４ #8037、,#8038を同時に実現するとなると下記になる!!
        this.comboBoxCtrl.addEventListener(this.comboBoxCtrl.inputElement, 'click', (ev: Event) => {
            ev.preventDefault();
        }, true);//wjcInput.ComboBoxのデフォルトの動作を何よりも先にインターセプトしたいので、Tunneling Phaseで

        return comboBox;
    }

    /**
     * 
     */
    private setEvents() {
        this.btnDecrease.on('click', this.decrease.bind(this));
        this.btnIncrease.on('click', this.increase.bind(this));
    }

    /**
     * 
     * @returns
     */
    private decrease() {
        const _selectedIndex = this.selectedIndex;
        if (0 > _selectedIndex - 1) { return; }
        this.selectedIndex = _selectedIndex - 1;
        //this.setBehavior();
    }

    /**
     * 
     * @returns
     */
    private increase() {
        const _selectedIndex = this.selectedIndex;
        const length = this.items.length;
        if (length < (_selectedIndex + 1) + 1) { return; }
        this.selectedIndex = _selectedIndex + 1;
        //this.setBehavior();
    }

    /**
     * 
     * @param currentValue
     * @perValue
     */
    private setBehavior() {
        const _selectedIndex = this.selectedIndex;
        const length = this.items.length;

        this.btnIncrease.removeClass('disabled');
        this.btnDecrease.removeClass('disabled');

        if (length == _selectedIndex + 1) {
            this.btnIncrease.addClass('disabled');
        } else if (0 == _selectedIndex) {
            this.btnDecrease.addClass('disabled');
        }
    }

    /** 
     * 
     */
    private completed() {
        this.setBehavior();
    }
}